<template>
    <div class="px-3">
        <div class="card">
            <div class="card-header">
                <h4>{{ $t('certificates.template.title') }}</h4>
            </div>
            <div class="card-body">
                <div class="form-row">
                    <div class="form-group col-md-10 col-sm-12">
                        <label class="font-weight-bold" :for="'lecturerCertificateDefaultReport' + _uid">{{ $t('certificates.template.label') }}</label>
                        <dynamic-dropdown :apiUrl="`/api/certificates/getReportsDropdownModels`"
                                          v-model="model.lecturerCertificateDefaultReportId"
                                          :hasStringId="true"
                                          :id="'lecturerCertificateDefaultReport' + _uid"
                                          :name="'lecturerCertificateDefaultReport' + _uid"
                                          :required="false"
                                          :fieldName="$t('certificates.template.noData')"
                                          :showGoToSelection="false"
                                          :filter="'contains'"
                                          :height="500"
                                          aria-describedby="lecturerCertificateDefaultReportHelp">
                        </dynamic-dropdown>
                        <small id="lecturerCertificateDefaultReportHelp" class="form-text text-muted">{{ $t("certificates.template.help") }}</small>
                    </div>

                    <div class="form-group col-md-2 col-sm-12">
                        <label class="font-weight-bold"> </label>
                        <div>
                            <button v-if="allowEdit && hasEditRights"
                                    type="button"
                                    class="btn btn-success"
                                    @click.stop="save"
                                    :disabled="saving">
                                <i v-if="saving" class="fas fa-spinner fa-spin mr-2"></i>
                                <i v-else class="fas fa-save mr-2"></i>
                                {{ $t('buttons.save.btnText')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { RegisterEntityExtension } from '@/models/models';
    import { EventClaims } from '@/models/enums';
    import DynamicDropdown from '@/components/dropdown/DynamicDropdown'
    import { mapGetters } from 'vuex';

    export default {
        props: {
            model: {
                type: RegisterEntityExtension
            },
            allowEdit: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DynamicDropdown,
        },
        data() {
            return {
                saving: false,
                test: '',
                test1: ''
            }
        },
        methods: {
            save() {
                this.saving = true;

                this.$http
                    .put('/api/certificates/updateEventLecturerCertificateTemplate', this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('buttons.save.btnText'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('buttons.save.btnText'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    }).then(() => { this.saving = false });
            },
            haveClaimWritePermisions(claim) {
                if (!claim) {
                    return false;
                }

                if (claim.create || claim.update) {
                    return true;
                }

                return false;
            },
        },
        computed: {
            ...mapGetters(['eventClaims']),
            hasEditRights() {
                const claim = this.eventClaims[EventClaims.EventParticipantManagement];
                return this.haveClaimWritePermisions(claim);
            }
        }
    }
</script>
